// T2T-05-C4 — Typing indicator. Shows up to 3 names + "+N others typing".

import React from "react";
import PropTypes from "prop-types";

const MAX_VISIBLE = 3;

export default function TypingIndicator({ names }) {
  if (!names || names.length === 0) return null;
  const visible = names.slice(0, MAX_VISIBLE);
  const overflow = names.length - visible.length;

  let label;
  if (visible.length === 1) label = `${visible[0]} is typing`;
  else if (visible.length === 2) label = `${visible[0]} and ${visible[1]} are typing`;
  else label = `${visible.slice(0, -1).join(", ")}, ${visible[visible.length - 1]} are typing`;
  if (overflow > 0) label += ` +${overflow} other${overflow > 1 ? "s" : ""}`;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        fontSize: 11,
        color: "var(--t2t-text-muted)",
        padding: "4px 0",
        fontStyle: "italic",
      }}
      aria-live="polite"
    >
      <span className="t2t-typing-dots" aria-hidden>
        <span /><span /><span />
      </span>
      <span>{label}…</span>
    </div>
  );
}

TypingIndicator.propTypes = {
  names: PropTypes.array.isRequired,
};
